import { Subscription } from 'rxjs/Subscription';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import store from './../../../store/store.module';
import swal from 'sweetalert2';
import {
  FETCH_DELIVERYS_REQUESTED,
  SELECT_ALL_VISIBLE_DELIVERY,
  DELIVER_PRODUCT_REQUESTED, REINDEX_SELECTED_ITEM,
  REMIND_DRIVER_ON_HIS_WAY_REQUESTED, SELECT_ALL_DELIVERY, RESET_DELIVERY_SELECTION
} from './list.actions';
import * as _ from 'lodash';
import { NotificationService } from '../../../common/services/notification/notification.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {GET_ALL_COURIERS_REQUESTED} from "../../courier/courier.action";
import {FETCH_CONSTANTS_REQUESTED} from "../../../store/constant/list/list.actions";
import {openWindow} from "../../../store/download/download.actions";
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import {POPULATE_CONFIRM_ORDER_REQUESTED} from "../../order/edit/edit.actions";
import {DOWNLOAD_REQUESTED, RESET_PRODUCT_SELECTION} from "../../product/list/list.actions";
import {EDIT_DELIVERYS_REQUESTED} from "../edit/edit.actions";
import {GET_ALL_DELIVERY_TIMINGS_REQUESTED} from "../delivery.actions";
const READY_TO_BE_SHIPPED = 'READY_TO_BE_SHIPPED';
const SHIPPING = 'SHIPPING';
const SHIPPED = 'SHIPPED';
const defaultFilters = {
  delivery_type: '',
  expected_date: Object.freeze(['', '']),
  today: null,
  tomorrow: null,
  has_expected_date: null,
  only_international: false
};
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit, OnDestroy {
  public navigationSubscription: Subscription;
  public store = store;
  public product_status = {
    SHIPPING, READY_TO_BE_SHIPPED, SHIPPED
  };
  @ViewChild('popup') private popup: SwalComponent;
  public search_actions = [
    {
      label: 'Product SKU',
      placeholder: 'Search by Delivery ID'
    },
    {
      label: 'Keyword',
      placeholder: 'Search by product name'
    }
  ];
  private filters = {};
  private orders = {
    delivery_type: null,
    expected_date: '',
    delivery_area: null
  };
  public filterDeliveryUntouched = true;
  public customFilter = {
    ...defaultFilters
  };
  public isOpen = false;
  public untouched = true;
  constructor(private notification: NotificationService, private activeRouter: ActivatedRoute, private router: Router) {
    this.activeRouter = activeRouter;
    this.router = router;
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.customFilter = {
          ...defaultFilters
        };
        if (!_.isUndefined(this.activeRouter.snapshot.queryParams.filters)) {
          let filters = this.activeRouter.snapshot.queryParams.filters;
          if (filters) {
            this.filters = JSON.parse(filters);
            if (typeof this.filters['only_international'] === 'undefined') {
              this.filters['only_international'] = false;
            }
            this.customFilter = _.defaults({...this.filters}, {
              ...defaultFilters
            });
          }
        } else {
          this.filters['status'] = READY_TO_BE_SHIPPED;
          this.filters['only_international'] = false;
        }
        if (!_.isUndefined(this.activeRouter.snapshot.queryParams.orders)) {
          let orders = this.activeRouter.snapshot.queryParams.orders;
          if (orders) {
            this.orders = JSON.parse(orders);
          }
        }
        if (!_.isUndefined(this.activeRouter.snapshot.queryParams.untouched)) {
          this.untouched = false;
        }
        store.dispatch({
          type: FETCH_DELIVERYS_REQUESTED,
          data: {
            pagination: this.getQuery(),
            filters: this.filters,
            sorts: this.orders,
            defaultSelection: false,
            untouched: this.untouched
          }
        });
        store.dispatch({ type: GET_ALL_COURIERS_REQUESTED });
        store.dispatch({ type: FETCH_CONSTANTS_REQUESTED });
        store.dispatch({ type: GET_ALL_DELIVERY_TIMINGS_REQUESTED });
        let test = this.activeRouter.snapshot.queryParams.filter_delivery_status;
        if (test) {
          this.isOpen = true;
        }
        this.untouched = false;
      }
    });
  }

  ngOnInit() {}

  ngOnDestroy() {
    if (!_.isUndefined(this.navigationSubscription)) {
      this.navigationSubscription.unsubscribe();
    }
  }

  public getQuery(): object {
    let supportedParams = ['sort', 'constraints', 'page', 'per_page', 'search', 'skus', 'filter_delivery_status'];
    let queryParams = { page: 1, per_page: 100 };
    if (_.keys(this.activeRouter.snapshot.queryParams).length > 0) {
      queryParams = _.assign(queryParams, this.activeRouter.snapshot.queryParams);
    }

    return _.pick(queryParams, supportedParams);
  }
  public getCurrentQueryString() {
    let params = {
      filters: JSON.stringify(this.filters),
      orders: JSON.stringify(this.orders)
    };
    if (this.activeRouter.snapshot.queryParams.search) {
      params['search'] = this.activeRouter.snapshot.queryParams.search;
    }
    return params;
  }
  _filter(key, value) {
    if (value === '') {
      delete this.filters[key];
    } else {
      this.filters[key] = value;
    }
  }
  filter(key, value) {
    // to make selection refresh on status change
    // if (key === 'status') {
    //   if (value !== this.filters['status']) {
    //     this.untouched = true;
    //   }
    // }
    this._filter(key, value);
    this.filterDeliveryUntouched = false;
    this.router.navigate(['delivery/list'], { queryParams: this.getCurrentQueryString()});
  }
  filterDeliveryType(value) {
    let curDeliveryType = this.customFilter['delivery_type'] ? this.customFilter['delivery_type'] : [] as any;
    let valueIndex = curDeliveryType.indexOf(value);
    if (valueIndex === -1) {
      curDeliveryType.push(value);
    } else {
      curDeliveryType = curDeliveryType.filter(s => s !== value);
    }
    if (curDeliveryType.length === 0) {
      curDeliveryType = '';
    }
    this.filter('delivery_type', curDeliveryType);
  }
  resetFilter() {
    this.filterDeliveryUntouched = true;
    let params = {
      filters: JSON.stringify({ status: this.filters['status'] ? this.filters['status'] : READY_TO_BE_SHIPPED, only_international: false }),
      search: this.activeRouter.snapshot.queryParams.search
    };
    this.router.navigate(['delivery/list'], { queryParams: params});
  }
  open() {
    this.isOpen = !this.isOpen;
  }
  selectAllDeliveries(event) {
    store.dispatch({ type: SELECT_ALL_VISIBLE_DELIVERY, data: event.checked });
  }
  havingReadyToShipFilter() {
    if (this.filters['status'] === READY_TO_BE_SHIPPED) {
      return true;
    } else {
      return false;
    }
  }

  havingInDeliveryFilter() {
    if (this.filters['status'] === SHIPPING) {
      return true;
    } else {
      return false;
    }
  }

  havingShippedFilter() {
    if (this.filters['status'] === SHIPPED) {
      return true;
    } else {
      return false;
    }
  }

  deliver() {
    let newWindow = openWindow();
    store.dispatch({ type: REINDEX_SELECTED_ITEM });
    let bulkData = [].concat.apply([], this.getCheckedIds(READY_TO_BE_SHIPPED).map(id => {
      return {
        id: id,
        data: {
          status: SHIPPING
        }
      };
    }));
    if (bulkData.length > 0) {
      this._filter('status', SHIPPING);
      store.dispatch({ type: DELIVER_PRODUCT_REQUESTED, data: bulkData, fetchData: {
          pagination: this.getQuery(),
          filters: this.filters,
          sort: this.getQuery()['sort'],
          defaultSelection: true
        },
        download: {
          mediaPath: store.getState().RootReducer.config.mediaUrl,
          type: 'delivery',
          extension: 'pdf',
          orderIds: bulkData.map(s => s.id).join(','),
          windowReference: newWindow
        }});
    }
  }
  reprintPaper() {
    let newWindow = openWindow();
    store.dispatch({
      type: DOWNLOAD_REQUESTED,
      data: {
        mediaPath: store.getState().RootReducer.config.mediaUrl,
        type: 'delivery',
        extension: 'pdf',
        orderIds: this.getCheckedIds().join(','),
        windowReference: newWindow
      }
    });
  }
  confirmDelivery() {
    store.dispatch({ type: REINDEX_SELECTED_ITEM });
    let bulkData = [].concat.apply([], this.getCheckedIds(SHIPPING).map(id => {
      return {
        id: id,
        data: {
          status: SHIPPED
        }
      };
    }));
    if (bulkData.length > 0) {
      this._filter('status', SHIPPED);
      store.dispatch({ type: DELIVER_PRODUCT_REQUESTED, data: bulkData, fetchData: {
          pagination: this.getQuery(),
          filters: this.filters,
          sort: this.getQuery()['sort'],
          defaultSelection: true
        }});
      store.dispatch({ type: POPULATE_CONFIRM_ORDER_REQUESTED});
    }
  }
  confirmSingleDelivery(s) {
    store.dispatch({ type: DELIVER_PRODUCT_REQUESTED, data: [
        {
          id: s.id,
          data: {
            status: SHIPPED
          }
        }
      ], fetchData: {
        pagination: this.getQuery(),
        filters: this.filters,
        sort: this.getQuery()['sort'],
        defaultSelection: true
      }});
  }
  sendDriverOnHisWayReminder(s) {
    store.dispatch({
      type: REMIND_DRIVER_ON_HIS_WAY_REQUESTED,
      data: {
        id: s.id
      }
    });
  }
  changeToReadyToBeShipped(item, popup, content) {
    if (item.comments) {
      store.dispatch({ type: DELIVER_PRODUCT_REQUESTED, data: [
          {
            id: item.id,
            data: {
              status: READY_TO_BE_SHIPPED,
              comments: item.comments
            }
          }
        ], fetchData: {
          pagination: this.getQuery(),
          filters: this.filters,
          sort: this.getQuery()['sort'],
          defaultSelection: true
        }});
    }
    return item;
  }
  verifyDangerousPassword(password) {
    let date = new Date();
    date.setHours(0, 0, 0, 0);
    let dateStart = (date.getTime() / 1000 | 0);
    let dateLimit = new Date();
    dateLimit.setHours(24, 0, 0, 0);
    let dateUntil = (dateLimit.getTime() / 1000 | 0);
    console.log(dateStart, dateUntil);
    return dateStart <= parseInt(password) && dateUntil >= parseInt(password);
  }
  changeToShipping(item) {
    if (item.password && this.verifyDangerousPassword(item.password)) {
      store.dispatch({ type: DELIVER_PRODUCT_REQUESTED, data: [
          {
            id: item.id,
            data: {
              status: SHIPPING
            }
          }
        ], fetchData: {
          pagination: this.getQuery(),
          filters: this.filters,
          sort: this.getQuery()['sort'],
          defaultSelection: true
        }});
    } else {
      item.password = '';
    }
    return item;
  }

  checkComments(item, popup) {
    popup.show().then((res) => {
      if (res.value === true) {
        if (!item.comments) {
          this.notification.show('warning', 'comments cannot be empty', 5000);
        }
      }
    });
  }
  checkPassword(item, popup) {
    popup.show().then((res) => {
      if (res.value === true) {
        if (!item.password) {
          this.notification.show('warning', 'password cannot be empty', 5000);
        }
        if (!this.verifyDangerousPassword(item.password)) {
          this.notification.show('warning', 'wrong password!', 5000);
        }
      }
    });
  }

  sortBy(field) {
    for (let prop in this.orders) {
      if (prop === field) {
        if (this.orders[field] === null) {
          this.orders[field] = '-';
        } else {
          if (this.orders[field] === '-') {
            this.orders[field] = '';
          } else if (this.orders[field] === '') {
            this.orders[field] = null;
          }
        }
      }
    }
    this.router.navigate(['delivery/list'], { queryParams: this.getCurrentQueryString()});
  }

  cancelDelivery(data) {
    store.dispatch({ type: EDIT_DELIVERYS_REQUESTED, data: {
        id: data.id,
        cancelled_at: true
      }, queryParams: this.getCurrentQueryString()
    });
  }

  editDeliveryTiming(data) {
    store.dispatch({ type: EDIT_DELIVERYS_REQUESTED, data: {
        id: data.id,
        delivery_timing_id: data.delivery_timing_id
    }, noredirect: true});
  }

  getCheckedIds(status = null) {
    let curItems = store.getState().Delivery.list.items;
    if (status) {
      curItems = curItems.filter(s => s.status === status);
    }
    let curItemIds = curItems.map(s => s.id);
    let checkedItems = store.getState().Delivery.list.checkedItems;
    if (status) {
      checkedItems = checkedItems.filter(s => s.status === status);
    }
    let checkedItemIds = checkedItems
      .filter(s => s.checked === true)
      .filter(s => curItemIds.indexOf(s.id) === -1)
      .map(s => s.id);
    return checkedItemIds.concat(curItems.filter(s => s.checked === true).map(s => s.id));
  }
  getSelectedNum() {
    if (store.getState().Delivery.list.fetched) {
      return this.getCheckedIds().length;
    } else {
      return 0;
    }
  }
  resetSelected() {
    store.dispatch({ type: RESET_DELIVERY_SELECTION });
  }
}
